import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Loader, Alert, Button, Modal } from '@grandvisionhq/common';
import { useDynamicModule } from '@grandvisionhq/utils';
import PreferredStoreSummary from './PreferredStoreSummary.js';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storeModule = yield import(/* webpackChunkName: 'grandvisionhq-stores-v2' */ '@grandvisionhq/stores-v2');
        return storeModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePreferredStoresModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/stores-v2', [])
;
const PreferredStore = ({ labels , isModalOpen , onStoreSelect , onOpenModal , onCloseModal , storeCode , errorElement  })=>{
    const [module, loading, error] = usePreferredStoresModule();
    if (loading) {
        return /*#__PURE__*/ React__default.createElement(Loader, null);
    }
    if (error || !module) {
        return /*#__PURE__*/ React__default.createElement(Alert, {
            type: "error",
            notifyScreenReader: false,
            message: labels.error
        });
    }
    const { Containers , StoreFinderProvider , Components  } = module;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, errorElement, !storeCode && !isModalOpen && /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("p", null, labels.noStoreSelected), /*#__PURE__*/ React__default.createElement(Button, {
        "data-t": "edit-preferred-store",
        className: "preferred-store__add-store",
        variant: "outline",
        size: "small",
        color: "primary",
        caption: labels.addStore,
        onClick: onOpenModal
    })), storeCode && !isModalOpen && /*#__PURE__*/ React__default.createElement(PreferredStoreSummary, {
        preferredStoreCode: storeCode.toString(),
        onEdit: onOpenModal,
        className: "preferred-store__summary"
    }), isModalOpen && /*#__PURE__*/ React__default.createElement(Modal, {
        className: "preferred-store__modal",
        showIcon: true,
        iconClassName: "preferred-store__modal__close",
        isOpen: isModalOpen,
        onModalClose: onCloseModal
    }, /*#__PURE__*/ React__default.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container"
    }, /*#__PURE__*/ React__default.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React__default.createElement(StoreListTopContent, {
            title: labels.modalTitle,
            // TODO: Add a better label once confirmed by BA.
            description: labels.modalDescription
        }),
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        })
    }))));
};
var PreferredStore$1 = PreferredStore;

export { PreferredStore$1 as default };
//# sourceMappingURL=PreferredStore.js.map
